import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from './lib/queryClient';
import './styles/global.css';

async function bootstrap(): Promise<void> {
  const reviewMode = import.meta.env.VITE_RITHMIC_REVIEW_MODE === 'true';
  const App = reviewMode
    ? (await import('./review/RithmicReviewApp')).default
    : (await import('./App')).default;

  // The isolated conformance build is authenticated by nginx at the entire
  // /rithmic-review/ prefix. It must not initialize Firebase or expose any
  // normal application authentication/navigation surface.
  if (!reviewMode) {
    const { initFirebase } = await import('./lib/firebase');
    initFirebase();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <App />
        </BrowserRouter>
        {!reviewMode && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
